import {SuiteUser} from '../data.types';


export class Unit {
    constructor(
        public id: number = null,
        public buildingId: number = null,
        public buildingName: string = '',
        public suiteNumber: string = '',
        public buzz: string = '',
        public proportionateShare: string = '',
        public emergencyContact: string = '',
        public emergencyContacts: Array<any> = [],
        public legalDescription: string = '',
        public enterPhone: string = '',
        public keyFob: string = '',
        public keyCode: string = '',
        public powerAttorney: string = '',
        public allowedVisitor: string = '',
        public note: string = '',
        public rentedOut: number = 0,
        public fromFiveReceived: boolean = false,
        public occupancyDate: string = '',
        public suiteUser: Array<SuiteUser> = [],
        public parking: Array<number> = [],
        public locker: Array<number> = [],
        public bikeRack: Array<number> = [],
        public pet: Array<number> = [],
        public level: string = '',
        public subName: string = '',
        public permissionToEnter: string = '',
        public buzzFields = [],
        public keyFobFields = [],
        public keyCodeFields = [],
        public instructions = [],
        public checked: boolean = false,
        public isCanEdit: boolean = true,
        public isCanDelete: boolean = true,
        public formFields = {
            building: {editMode: false},
            suiteNumber: {editMode: false},
            buzz: {editMode: false},
            proportionateShare: {editMode: false},
            emergencyContact: {editMode: false},
            legalDescription: {editMode: false},
            enterPhone: {editMode: false},
            keyFob: {editMode: false},
            keyCode: {editMode: false},
            powerAttorney: {editMode: false},
            allowedVisitor: {editMode: false},
            note: {editMode: false},
            rentedOut: {editMode: false},
            fromFiveReceived: {editMode: false},
            occupancyDate: {editMode: false},
            level: {editMode: false},
            subName: {editMode: false},
            permissionToEnter: {editMode: false},
            commonElementsFee: {editMode: false},
        },
        public commonElementsFee: string = ''
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/Unit.ts